<template>
  <div id="webViewPop" class="popWrap nowOpen">
    <span class="blind focusSet first" tabindex="0"></span>
    <div class="popup">
      <div class="popContain">
        <div class="popCont full hasBtn" tabindex="-1" role="dialog">
          <div class="popHead">
            <h1 class="titH1" v-html="pageName">
              <!-- {{ pageName }} -->
            </h1>
          </div>
          <div class="popBody">
            <div class="popInner">
              <section class="termsDetail">
                <!-- 본문 (s) -->
                <slot />
                <!-- 본문 (e) -->
              </section>
            </div>
          </div>
          <slot name="bottomButtonArea">
            <div class="btnArea sticky">
              <slot name="bottomButton">
                <button type="button" class="btn_p" @click="$emit('close')">
                  동의
                </button>
              </slot>
            </div>
          </slot>
          <slot name="closeButton">
            <button type="button" class="btnIco_close" @click="$emit('close')">
              <span>팝업 닫기</span>
            </button>
          </slot>
        </div>
      </div>
    </div>
    <span class="blind focusSet last" tabindex="0"></span>
    <ProgressBar ref="progress"></ProgressBar>
  </div>
</template>
<script>
import ProgressBar from '@/views/app/comm/ProgressBar';

export default {
  name: 'WebViewPop',
  components: {
    ProgressBar,
  },
  props: ['pageName', 'webView'],
  watch: {
    // webView() {
    //   this.$refs.progress.loadingEnd();
    // },
  },
  mounted() {
    // if (this.pageName === '전체 약관') {
    //   this.$refs.progress.loadingStart();
    // }
  },
};
</script>
